define('responsive-gameday-game-switch-mediator/src/js/GameSwitchMediator',['require','exports','module','jquery','app-console/app-console','es6ish-class/es6ish-class','message-service/message-service','gameday-index-url-hasher/enums/HashEvents','GameDayCore/GDModel/enums/events/EventTypes'],function (require, module, exports) {

    var $ = require('jquery'),
        logg       = new (require( "app-console/app-console" ))({ns : 'GameSwitchMediator'}),
        es6ishClass = require('es6ish-class/es6ish-class'),
        Dispatcher = require("message-service/message-service"),
        HashEvents = require('gameday-index-url-hasher/enums/HashEvents'),
        EventTypes = require("GameDayCore/GDModel/enums/events/EventTypes");

    var instance = null;

 
    var GameSwitchMediator = es6ishClass(function() {

        Dispatcher.addListener(HashEvents.UPDATE, function(data) {
            logg.info('SOMETHING CHANGED',data);
        });

        Dispatcher.addListener(HashEvents.GAME_ID_CHANGED, function(data) {
            logg.info('GAME_ID_CHANGED',data);
        });

        Dispatcher.addListener(HashEvents.GAME_STATE_CHANGED, function(data) {
            logg.info('GAME_STATE_CHANGED',data);
        });

        Dispatcher.addListener(EventTypes.INIT_DATA_LOADED, function(data) {
            logg.info('INIT_DATA_LOADED',data);
            //Dispatcher.publish(EventTypes.UPDATE);
        });

        Dispatcher.addListener(EventTypes.UPDATE, function(data) {
            logg.info('UPDATE GAME DATA',data);
        });
    });

    GameSwitchMediator.define({

    });
 
    function getInstance() {
        if (!instance) {
            instance = new GameSwitchMediator();
        }
        return instance;
    }

    return getInstance();
});
